export const EDIT_USER = 'edit_user';
export const SET_PET_POOJA_SYNCED = 'set-pet-pooja-synced';
